var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',{attrs:{"label":_vm.label,"theme":"icon-right","color":"black","text-color":"black","icon-color":_vm.iconColor,"icon":_vm.icon},on:{"click":_vm.toggleStatus}})}
var staticRenderFns = []

export { render, staticRenderFns }